export enum AccountType  {
    COMPANY = "Company",
    PERSON = "Person",
    UNKNOWN = "UNKNOWN",
    SUBLIME_EMPLOYEE = "Sublime employee"
}